var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increase-decrease-number"},[_c('input-number',{ref:"inputNumber",attrs:{"element-id":_vm.elementId,"max":_vm.max,"min":_vm.min,"step":_vm.step,"disabled":_vm.disabled,"editable":_vm.editable,"value":_vm.currentCount,"active-change":false},on:{"on-change":_vm.changeHandler}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5a9aff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FineartNumber.vue
// module id = null
// module chunks = 